// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"15161a15","337":"c55382f5","455":"73f96a7a"}[chunkId] + ".chunk.js";
};